import { useEffect, useState } from "react";
import { App as AntApp, ConfigProvider } from "antd";
import { auth } from "../shared/auth.js";
import { LoginScreen } from "../features/auth/LoginScreen.js";
import { Workspace } from "./workspace.js";
import { StepUpHost } from "../shared/ui/StepUpHost.js";
import { themeFor, type Mode } from "./theme.js";

/** Theme/font state lives here so ConfigProvider (which must wrap AntApp) is stateful; then the
 *  authed gate: Workspace (multi-tab) or the login screen. */
export function Shell() {
  const [mode, setMode] = useState<Mode>(() => (localStorage.getItem("giftme2.theme") as Mode) || "day");
  const [fontSize, setFontSize] = useState<number>(() => Number(localStorage.getItem("giftme2.font")) || 13);
  const [authed, setAuthed] = useState(auth.isAuthed());
  useEffect(() => { localStorage.setItem("giftme2.theme", mode); }, [mode]);
  useEffect(() => { localStorage.setItem("giftme2.font", String(fontSize)); }, [fontSize]);

  return (
    <ConfigProvider theme={themeFor(mode, fontSize)}>
      <AntApp>
        <StepUpHost />
        {authed
          ? <Workspace mode={mode} setMode={setMode} fontSize={fontSize} setFontSize={setFontSize} />
          : <LoginScreen onLogin={() => setAuthed(true)} />}
      </AntApp>
    </ConfigProvider>
  );
}
